export const DMS_MODULE = 'Uzaverka';
export const NAME = 'Uzaverka';
